/* eslint import/export: 0 */
import Login from '@/app/pages/Login/Index'
import Callback from '@/app/components/Callback'
import Page404 from '@/app/components/404'
import Start from '@/app/pages/Start/Index'
import Home from '@/app/pages/Home/Index'
import CLODashboard from '@/app/pages/CLO/Dashboard'

// Routes
const routes = [
  {
    path: '/',
    redirect: '/clo/:locale(en|fr)?'
  },
  // Select app screen
  {
    path: '/select-app/:locale(en|fr)?',
    name: 'start.index',
    component: Start,
    meta: {
      auth: true,
      permission: 'admin',
      fail: '/login',
      breadcrumb: 'Select dashboard'
    }
  },
  // Tuango CLO
  {
    path: '/:section(clo)/:locale(en|fr)?',
    component: Home,
    name: 'clo.home',
    // If the user needs to be authenticated to view this page
    meta: {
      group: 'CloDashboard',
      auth: true,
      permission: 'admin',
      fail: '/login',
      breadcrumb: 'Home'
    },
    children: [
      {
        path: 'dashboard',
        component: CLODashboard,
        name: 'clo.dashboard',
        meta: {
          group: 'CloDashboard',
          auth: true,
          permission: 'admin',
          fail: '/login',
          breadcrumb: 'Dashboard'
        }
      },
      {
        path: 'surveys',
        name: 'clo.surveys',
        component: () => import(/* webpackChunkName: "clo_surveys" */ '@/app/pages/CLO/Surveys'),
        meta: {
          group: 'CloDashboard',
          auth: true,
          permission: 'admin',
          fail: '/login',
          breadcrumb: 'Surveys'
        }
      },
      {
        path: 'offer-details/:offerId',
        component: () => import('@/app/pages/CLO/Deal'),
        meta: {
          group: 'CloDeal',
          auth: true,
          permission: 'admin',
          fail: '/login',
          breadcrumb: 'Deal'
        },
        children: [
          {
            path: '',
            name: 'clo.deal.stats',
            component: () => import(/* webpackChunkName: "clo_stats" */ '@/app/pages/CLO/Stats'),
            meta: {
              group: 'CloDeal',
              auth: true,
              permission: 'admin',
              fail: '/login',
              breadcrumb: 'Statistics'
            }
          },
          {
            path: 'clients',
            name: 'clo.deal.transactions',
            component: () => import(/* webpackChunkName: "clo_transactions" */ '@/app/pages/CLO/Transactions'),
            meta: {
              group: 'CloDeal',
              auth: true,
              permission: 'admin',
              fail: '/login',
              breadcrumb: 'Clients'
            }
          },
          {
            path: 'claims-chart',
            name: 'clo.deal.claims',
            component: () => import(/* webpackChunkName: "clo_stats" */ '@/app/pages/CLO/ClaimsChart'),
            meta: {
              group: 'CloDeal',
              auth: true,
              permission: 'admin',
              fail: '/login',
              breadcrumb: 'Claims Chart'
            }
          },
          {
            path: 'sales-chart',
            name: 'clo.deal.sales',
            component: () => import(/* webpackChunkName: "clo_stats" */ '@/app/pages/CLO/SalesChart'),
            meta: {
              group: 'CloDeal',
              auth: true,
              permission: 'admin',
              fail: '/login',
              breadcrumb: 'Sales Chart'
            }
          },
          // {
          //   path: 'charts-3',
          //   name: 'clo.deal.chart3',
          //   component: () => import(/* webpackChunkName: "clo_stats" */ '@/app/pages/CLO/Chart3'),
          //   meta: {
          //     group: 'CloDeal',
          //     auth: true,
          //     permission: 'admin',
          //     fail: '/login',
          //     breadcrumb: 'Chart 3'
          //   }
          // },
          // {
          //   path: 'claims-map',
          //   name: 'clo.deal.claims_map',
          //   component: () => import(/* webpackChunkName: "clo_claims" */ '@/app/pages/CLO/Map'),
          //   meta: {
          //     group: 'CloDeal',
          //     auth: true,
          //     permission: 'admin',
          //     fail: '/login',
          //     breadcrumb: 'Claims'
          //   }
          // },
          {
            path: 'contact-us',
            name: 'clo.deal.contactUs',
            component: () => import('@/app/pages/CLO/Staff'),
            meta: {
              group: 'CloDeal',
              auth: true,
              permission: 'admin',
              fail: '/login',
              breadcrumb: 'Contact us'
            }
          }
        ]
      }
      // {
      //   path: 'user/profile',
      //   name: 'clo.user.profile',
      //   component: () => import('@/app/pages/User/Profile'),
      //   meta: {
      //     group: 'User',
      //     auth: true,
      //     permission: 'admin',
      //     fail: '/login',
      //     breadcrumb: 'Profile'
      //   }
      // },
      // {
      //   path: 'clo/invoicing',
      //   name: 'clo.test.invoicing',
      //   component: () => import('@/app/pages/CLO/Invoicing'),
      //   meta: {
      //     group: 'Test',
      //     auth: true,
      //     permission: 'admin',
      //     fail: '/login',
      //     breadcrumb: 'Invoicing'
      //   }
      // }
    ]
  },
  // Tuango Traditional
  // {
  //   path: '/:section(traditional)/:locale(en|fr)?',
  //   name: 'home.index',
  //   component: Home,
  //
  //   // If the user needs to be authenticated to view this page
  //   meta: {
  //     auth: true,
  //     permission: 'admin',
  //     fail: '/login',
  //     breadcrumb: 'Home'
  //   },
  //   children: [
  //     {
  //       path: 'test/datatables',
  //       name: 'test.datatables',
  //       component: () => import('@/app/pages/Test/Datatables'),
  //       meta: {
  //         group: 'Test',
  //         auth: true,
  //         permission: 'admin',
  //         fail: '/login',
  //         breadcrumb: 'Clients'
  //       }
  //     },
  //     {
  //       path: 'test/stats',
  //       name: 'test.stats',
  //       component: () => import('@/app/pages/Test/Stats'),
  //       meta: {
  //         group: 'Test',
  //         auth: true,
  //         permission: 'admin',
  //         fail: '/login',
  //         breadcrumb: 'Stats'
  //       }
  //     },
  //     {
  //       path: 'test/calendar',
  //       name: 'test.calendar',
  //       component: () => import(/* webpackChunkName: "calendar" */ '@/app/pages/Test/Calendar'),
  //       meta: {
  //         group: 'Test',
  //         auth: true,
  //         permission: 'admin',
  //         fail: '/login',
  //         breadcrumb: 'Calendar'
  //       }
  //     },
  //     {
  //       path: 'test/user-card',
  //       name: 'test.userCard',
  //       component: () => import('@/app/pages/Test/UserCard'),
  //       meta: {
  //         group: 'Test',
  //         auth: true,
  //         permission: 'admin',
  //         fail: '/login',
  //         breadcrumb: 'Contact us'
  //       }
  //     },
  //     {
  //       path: 'test/deals',
  //       name: 'test.deals',
  //       component: () => import('@/app/pages/Deals/Index'),
  //       meta: {
  //         group: 'Test',
  //         auth: true,
  //         permission: 'admin',
  //         fail: '/login',
  //         breadcrumb: 'Deals'
  //       }
  //     },
  //     {
  //       path: 'test/amChart',
  //       name: 'test.chart',
  //       component: () => import('@/app/pages/Test/Chart'),
  //       meta: {
  //         group: 'Test',
  //         auth: true,
  //         permission: 'admin',
  //         fail: '/login',
  //         breadcrumb: 'Charts'
  //       }
  //     },
  //     {
  //       path: 'test/ammap',
  //       name: 'test.map',
  //       component: () => import('@/app/pages/Test/Map'),
  //       meta: {
  //         group: 'Test',
  //         auth: true,
  //         permission: 'admin',
  //         fail: '/login',
  //         breadcrumb: 'Map'
  //       }
  //     },
  //     {
  //       path: 'test/surveys',
  //       name: 'test.surveys',
  //       component: () => import('@/app/pages/Test/Surveys'),
  //       meta: {
  //         group: 'Test',
  //         auth: true,
  //         permission: 'admin',
  //         fail: '/login',
  //         breadcrumb: 'Surveys'
  //       }
  //     },
  //     {
  //       path: 'test/invoicing',
  //       name: 'test.invoicing',
  //       component: () => import('@/app/pages/Test/Invoicing'),
  //       meta: {
  //         group: 'Test',
  //         auth: true,
  //         permission: 'admin',
  //         fail: '/login',
  //         breadcrumb: 'Invoicing'
  //       }
  //     },
  //     {
  //       path: 'user/profile',
  //       name: 'traditional.user.profile',
  //       component: () => import('@/app/pages/User/Profile'),
  //       meta: {
  //         group: 'User',
  //         auth: true,
  //         permission: 'admin',
  //         fail: '/login',
  //         breadcrumb: 'Profile'
  //       }
  //     },
  //     {
  //       path: 'vouchers/redeem/:code',
  //       name: 'voucher.redeem',
  //       component: () => import('@/app/pages/Voucher/Index'),
  //       props: true,
  //       meta: {
  //         group: 'Voucher',
  //         auth: true,
  //         permission: 'admin',
  //         fail: '/login',
  //         breadcrumb: 'Redeem voucher'
  //       }
  //     }
  //   ]
  // },
  {
    path: '/login',
    name: 'login.index',
    component: Login,
    meta: {
      auth: false,
      permission: 'any',
      fail: '/login'
    }
  },
  {
    path: '/callback',
    component: Callback,
    meta: {
      auth: false,
      permission: 'any',
      fail: '/'
    }
  },
  {
    // not found handler
    path: '*',
    name: '404',
    component: Page404,
    meta: {
      auth: false,
      permission: 'any',
      fail: '/'
    }
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/app/routes.js